import isEmpty from 'lodash/isEmpty';
import { createBrowserHistory } from 'history';

const langInUrl = window.location.pathname.split('/')[1];
const historyInStorage = localStorage.getItem('history');

let baseUrl = localStorage.getItem('lang') || 'en';
if (['en', 'ar'].includes(langInUrl)) baseUrl = langInUrl;
localStorage.setItem('lang', baseUrl);

const history = createBrowserHistory({
  basename: baseUrl,
});

if (!isEmpty(historyInStorage)) {
  history.location = { ...JSON.parse(historyInStorage) };
  localStorage.removeItem('history');
}

export default history;
export const basename = `/${baseUrl}`;
